import { render, staticRenderFns } from "./streak.vue?vue&type=template&id=47418de3&scoped=true&"
import script from "./streak.vue?vue&type=script&lang=js&"
export * from "./streak.vue?vue&type=script&lang=js&"
import style0 from "./streak.vue?vue&type=style&index=0&id=47418de3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47418de3",
  null
  
)

export default component.exports